import { IonBackdrop, IonSpinner } from "@ionic/react";
import "./LoadingBackdrop.css";

const LoadingBackdrop = (visualizar) => {
  return (
    <>
      <IonBackdrop visible={visualizar} />
      <div id="box">
        <div className="loading-content">
          <IonSpinner name="crescent" />
          <p className="loading-text">Cargando...</p>
        </div>
      </div>
    </>
  );
};

export default LoadingBackdrop;
